import { mockOfficeAgent, mockCodeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-agent-transition';
const CONV_ID = 'conv-1';
const MD_BLOCK_ID = 'blk-at-md';
const TRANSITION_BLOCK_ID = 'blk-at-transition';
const MD2_BLOCK_ID = 'blk-at-md2';
const markdownText = "I'll need to check the fire code requirements for that. Let me hand this off to our expert.";
const transitionBlock = {
    type: 'agent_transition',
    block_id: TRANSITION_BLOCK_ID,
    block_index: 1,
    from_agent: mockOfficeAgent,
    to_agent: mockCodeAgent,
    transition_message: 'Let me check the NFPA code requirements for fire alarm systems...',
    chain_step: 1,
    chain_total: 2,
    context_summary: 'User asked about fire alarm inspection requirements for Building A.',
    nested: false
};
const codeResponseText = 'According to NFPA 72, fire alarm systems require annual inspections with specific testing protocols.';
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(transitionBlock, 200),
    makeBlockStart(MD2_BLOCK_ID, 2, 'markdown'),
    ...splitTextIntoDeltas(MD2_BLOCK_ID, codeResponseText),
    makeBlockEnd(MD2_BLOCK_ID),
    makeStreamEnd(RESPONSE_ID, 3, mockCodeAgent)
];
export const scenario = {
    name: 'Office → Code Agent Transition',
    description: 'Office Assistant streams a markdown response, then transitions to Fire Code Expert via an agent_transition block, followed by the expert response.',
    conversations: mockConversations,
    userMessage: 'What are the fire alarm inspection requirements for Building A?',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
